import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { TextButtonLink } from '@creditornot/cb-button';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Spinner } from '@creditornot/cb-progress';

import { useDashboardState } from './dashboardState';
import { Stack } from '../../common/components/cookbook/Stack';

const DashboardStateText = styled.div`
  font-weight: normal;
  font-size: 0.875rem;
  color: ${color.textSubdued};
`;

export const DashboardEmbedState = () => {
  const [state] = useDashboardState();

  return state === 'none' ? null : (
    <>
      {state === 'overdue' && (
        <Stack direction="row" gap="regularLarge" alignItems="center">
          <DashboardStateText>Dashboard having trouble loading</DashboardStateText>
          <TextButtonLink
            href="https://looker.wolt.com/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            Login
          </TextButtonLink>
          <TextButtonLink href={window.location.href}>Reload</TextButtonLink>
        </Stack>
      )}
      {state === 'loading' && (
        <Stack direction="row" gap="regularMedium" alignItems="center">
          <Spinner size="small" color="grey" />
          <DashboardStateText>Preparing the dashboard</DashboardStateText>
        </Stack>
      )}
      {state === 'success' && (
        <Stack direction="row" gap="regularMedium" alignItems="center">
          <Icon source={icons.checkmarkCircleFilled} color={color.textBrand} size="medium" />
          <DashboardStateText>Dashboard is ready</DashboardStateText>
        </Stack>
      )}
      {state === 'failure' && (
        <Stack direction="row" gap="regularMedium" alignItems="center">
          <Icon source={icons.checkmarkCircleFilled} color={color.textBrand} size="medium" />
          <DashboardStateText>Failed to load the dashboard</DashboardStateText>
        </Stack>
      )}
    </>
  );
};
